import React from 'react';

const ELLIPSIS = '…';

function getPageItems(page, totalPages) {
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  const items = [1];
  const start = Math.max(2, page - 1);
  const end = Math.min(totalPages - 1, page + 1);

  if (start > 2) items.push(ELLIPSIS);
  for (let p = start; p <= end; p += 1) items.push(p);
  if (end < totalPages - 1) items.push(ELLIPSIS);

  items.push(totalPages);
  return items;
}

export default function Pagination({
  page,
  totalPages,
  total,
  pageSize,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions = [20, 50, 100],
  disabled = false,
}) {
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);
  const showPages = totalPages > 1;

  return (
    <div className="pager">
      <div className="pager-info">
        {total === 0 ? 'No entries' : `${from}–${to} of ${total}`}
      </div>

      <div className="pager-controls">
        {showPages && (
          <>
            <button
              type="button"
              className="pager-btn"
              onClick={() => onPageChange(page - 1)}
              disabled={disabled || page <= 1}
              aria-label="Previous page"
            >
              ‹
            </button>

            {getPageItems(page, totalPages).map((item, index) =>
              item === ELLIPSIS ? (
                <span key={`gap-${index}`} className="pager-gap">
                  {ELLIPSIS}
                </span>
              ) : (
                <button
                  key={item}
                  type="button"
                  className={`pager-btn ${item === page ? 'is-active' : ''}`}
                  onClick={() => onPageChange(item)}
                  disabled={disabled}
                  aria-current={item === page ? 'page' : undefined}
                >
                  {item}
                </button>
              )
            )}

            <button
              type="button"
              className="pager-btn"
              onClick={() => onPageChange(page + 1)}
              disabled={disabled || page >= totalPages}
              aria-label="Next page"
            >
              ›
            </button>
          </>
        )}

        {onPageSizeChange && (
          <select
            className="pager-size"
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
            disabled={disabled}
            aria-label="Rows per page"
          >
            {pageSizeOptions.map((size) => (
              <option key={size} value={size}>
                {size} / page
              </option>
            ))}
          </select>
        )}
      </div>
    </div>
  );
}
